import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.link";
import "core-js/modules/web.dom-collections.iterator";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from "react";
import analytics from "web/script/analytics/analytics";
import GenericModal from "web/react/components/generic-modal/generic-modal";
import Button from "web/react/components/button/button";
import CookieSettingsOption from "web/react/components/cookie-settings-option/cookie-settings-option";
import { useDispatch } from "react-redux";
import store from "web/redux/store";
import { gettext } from "web/script/modules/django-i18n";
import { consentToAllCookies, CookieConsentLevel, rejectAllNonEssentialCookies, setCookieConsent } from "web/redux/ducks/cookie-consent";
import classnames from "classnames";
import styles from "./cookie-settings.css";

function CookieSettings(_ref) {
  var isOpen = _ref.isOpen,
      onModalClose = _ref.onModalClose;
  var dispatch = useDispatch();
  var reducerState = store.getState().cookieConsentReducer;
  var initialSelectedState = {
    customizationCookie: reducerState.acceptsCustomization,
    adCookie: reducerState.acceptsAds,
    analyticalCookie: reducerState.acceptsAnalytics
  };

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      formHasChanged = _useState2[0],
      setFormHasChanged = _useState2[1];

  var customizationCookieOptionID = "customization-cookie-option";
  var adCookieOptionID = "ad-cookie-option";
  var analyticalCookieOptionID = "analytical-cookie-option";

  function getCurrentSelectedState() {
    var customizationCookieOptionElement = document.getElementById(customizationCookieOptionID);
    var adCookieOptionElement = document.getElementById(adCookieOptionID);
    var analyticalCookieOptionElement = document.getElementById(analyticalCookieOptionID);
    return {
      customizationCookie: customizationCookieOptionElement ? customizationCookieOptionElement.getAttribute("checked") === "true" : false,
      adCookie: adCookieOptionElement ? adCookieOptionElement.getAttribute("checked") === "true" : false,
      analyticalCookie: analyticalCookieOptionElement ? analyticalCookieOptionElement.getAttribute("checked") === "true" : false
    };
  }

  function onClose() {
    setFormHasChanged(false);
    onModalClose();
  }

  function acceptAllOnClick() {
    // copied from cookie-banner.jsx - so we know what % of users accept all cookies
    analytics.event("Cookie consent", "Clicked", "Hide");
    dispatch(consentToAllCookies());
    onClose();
  }

  function acceptRequiredOnClick() {
    analytics.event("cookie_settings", "clicked", "accept_required");
    dispatch(rejectAllNonEssentialCookies());
    onClose();
  }

  function saveChangesOnClick() {
    analytics.event("cookie_settings", "clicked", "save_changes");

    function getConsentLevel(accepts) {
      return accepts ? CookieConsentLevel.Accepts : CookieConsentLevel.Rejects;
    }

    var currentSelectedState = getCurrentSelectedState();
    var cookieConsent = {
      customizationCookie: getConsentLevel(currentSelectedState.customizationCookie),
      adCookie: getConsentLevel(currentSelectedState.adCookie),
      analyticsCookie: getConsentLevel(currentSelectedState.analyticalCookie)
    };
    dispatch(setCookieConsent(cookieConsent));
    onClose();
  }

  function discardChangesOnClick() {
    onClose();
  }

  var acceptAllButtonProps = {
    text: gettext("cookie_notification.cookie_settings.accept_all.cta"),
    onClick: acceptAllOnClick
  };
  var acceptRequiredLinkProps = {
    text: gettext("cookie_notification.cookie_settings.accept_required.link"),
    onClick: acceptRequiredOnClick
  };
  var discardChangesLinkProps = {
    text: gettext("cookie_notification.cookie_settings.discard_changes.link"),
    onClick: discardChangesOnClick
  };
  var saveChangesButtonProps = {
    text: gettext("cookie_notification.cookie_settings.save_changes.cta"),
    onClick: saveChangesOnClick
  };

  function onSelectedChange() {
    var currentSelectedState = getCurrentSelectedState();

    if (currentSelectedState.customizationCookie !== initialSelectedState.customizationCookie || currentSelectedState.adCookie !== initialSelectedState.adCookie || currentSelectedState.analyticalCookie !== initialSelectedState.analyticalCookie) {
      setFormHasChanged(true);
    } else {
      setFormHasChanged(false);
    }
  }

  function finishedTextTransition() {
    var finishedLinkElement = document.getElementById("finished-link");
    var finishedButtonElement = document.getElementById("finished-button");

    if (finishedLinkElement && finishedButtonElement) {
      finishedLinkElement.classList.toggle(styles.fadeIn);
      finishedLinkElement.classList.toggle(styles.fadeOut);
      finishedButtonElement.classList.toggle(styles.fadeIn);
      finishedButtonElement.classList.toggle(styles.fadeOut);
    }
  } // the finished action items can be one of two different propositions - 'accept' or 'save'


  var _useState3 = useState(acceptAllButtonProps),
      _useState4 = _slicedToArray(_useState3, 2),
      finishedButtonProps = _useState4[0],
      setFinishedButtonProps = _useState4[1];

  var _useState5 = useState(acceptRequiredLinkProps),
      _useState6 = _slicedToArray(_useState5, 2),
      finishedLinkProps = _useState6[0],
      setFinishedLinkProps = _useState6[1];

  useEffect(function () {
    // fade out old text
    finishedTextTransition(); // change to new text (giving time for the old text to fade out)

    setTimeout(function () {
      if (formHasChanged) {
        setFinishedButtonProps(saveChangesButtonProps);
        setFinishedLinkProps(discardChangesLinkProps);
      } else {
        setFinishedButtonProps(acceptAllButtonProps);
        setFinishedLinkProps(acceptRequiredLinkProps);
      }
    }, 150); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formHasChanged]);
  useEffect(function () {
    // fade in new text
    finishedTextTransition();
  }, [finishedButtonProps]);
  return React.createElement(GenericModal, {
    isOpen: isOpen,
    onClose: onClose,
    className: styles.modal
  }, React.createElement("div", {
    className: styles.content
  }, React.createElement("div", {
    className: styles.title
  }, // "Cookie Settings"
  gettext("cookie_notification.cookie_settings.title")), React.createElement("div", {
    className: styles.options
  }, React.createElement(CookieSettingsOption, {
    optionID: "required-cookies",
    optionTitle: // Required Cookies
    gettext("cookie_notification.required_cookies.title"),
    isEssential: true,
    cookieDescription: gettext("cookie_notification.required_cookies.description")
  }), React.createElement(CookieSettingsOption, {
    optionID: customizationCookieOptionID,
    optionTitle: // "Site Customization"
    gettext("cookie_notification.site_customization.title"),
    isEssential: false,
    cookieDescription: gettext("cookie_notification.site_customization.description"),
    isSelected: initialSelectedState.customizationCookie,
    onChange: onSelectedChange
  }), React.createElement(CookieSettingsOption, {
    optionID: analyticalCookieOptionID,
    optionTitle: // "Analytical / Performance"
    gettext("cookie_notification.analytical_performance.title"),
    isEssential: false,
    cookieDescription: gettext("cookie_notification.analytical_performance.description"),
    isSelected: initialSelectedState.analyticalCookie,
    onChange: onSelectedChange
  }), React.createElement(CookieSettingsOption, {
    optionID: adCookieOptionID,
    optionTitle: // Personalized Advertising
    gettext("cookie_notification.personalised_advertising.title"),
    isEssential: false,
    cookieDescription: gettext("cookie_notification.personalised_advertising.description"),
    isSelected: initialSelectedState.adCookie,
    onChange: onSelectedChange
  })), React.createElement("div", {
    className: styles.finishedLink
  }, React.createElement("a", {
    id: "finished-link",
    className: classnames(styles.link, styles.fadeIn),
    onClick: finishedLinkProps.onClick
  }, finishedLinkProps.text)), React.createElement(Button, {
    className: "",
    fullHeight: false,
    fullWidth: true,
    openInNewTab: false,
    disabled: false,
    styleType: "tertiary",
    onClick: finishedButtonProps.onClick
  }, React.createElement("span", {
    id: "finished-button",
    className: styles.fadeIn
  }, finishedButtonProps.text))));
}

export default CookieSettings;